import React, { useEffect } from 'react';
import { FaCheckCircle, FaExclamationCircle, FaTimes } from 'react-icons/fa';
const PackageToast = ({ message, type = 'success', onClose }) => {
    useEffect(() => {
        const timer = setTimeout(() => {
            onClose();
        }, 3000);
        return () => clearTimeout(timer);
    }, [onClose]);

    const getIcon = () => {
        switch (type) {
            case 'success':
                return <FaCheckCircle />;
            case 'error':
                return <FaExclamationCircle />;
            default:
                return <FaCheckCircle />;
        }
    };
    return (
        <div className={`adm-pkg-toast adm-pkg-toast-${type}`}>
            <div className="adm-pkg-toast-icon">
                {getIcon()}
            </div>
            <div className="adm-pkg-toast-message">
                {message}
            </div>
            <button className="adm-pkg-toast-close" onClick={onClose}>
                <FaTimes />
            </button>
        </div>
    );
};
export default PackageToast;